// @ts-nocheck

import { Question } from '../components/questions'

export const page = async () => {
    Question()
}